// actions
import ACTIONS from "../../../constants/actions";
import { LOCAL_STORAGE } from "../../../constants/localStorageConstants";
// others
import { AXIOS_INSTANCE } from "../../../config.js";

const { AUTHORITIES, SELECTED_BRANCH } = LOCAL_STORAGE;

const { GET_AUTHORITIES_REQUEST, GET_AUTHORITIES_FAIL, CHANGE_BRANCH_SUCCESS } =
  ACTIONS;

export function requestChangeBranch() {
  return (dispatch) => {
    dispatch({
      type: GET_AUTHORITIES_REQUEST,
    });
    return AXIOS_INSTANCE.request({
      url: `/api/${
        JSON.parse(localStorage.getItem(SELECTED_BRANCH))["code"]
      }/authorities/token`,
      method: "GET",
    })
      .then((res) => {
        localStorage.setItem(AUTHORITIES, JSON.stringify(res.data.result));
        dispatch({
          type: CHANGE_BRANCH_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_AUTHORITIES_FAIL,
        });
      });
  };
}
